import { Controller } from '@hotwired/stimulus'

const SCROLL_SPEED = 1

export default class extends Controller {
  static targets = ['slider', 'prevBtn', 'nextBtn']

  connect() {
    this.scrollRaf = null

    this.#slider.slick({
      slidesToShow: 3.08,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2.08 } },
        { breakpoint: 576, settings: { slidesToShow: 1.08 } },
      ],
    })

    this.#slider.on('afterChange', () => this.#updateArrows())
    this.#updateArrows()
  }

  disconnect() {
    this.stopScroll()
    if (this.#slider.hasClass('slick-initialized')) {
      this.#slider.slick('unslick')
    }
  }

  prev() { this.#slider.slick('slickPrev') }
  next() { this.#slider.slick('slickNext') }

  startScroll() {
    if (this.scrollRaf) return

    const track = this.#track
    const list = this.#list
    if (!track || !list) return

    const maxScroll = track.scrollWidth - list.offsetWidth

    const animate = () => {
      const next = this.#getTranslateX(track) - SCROLL_SPEED

      if (Math.abs(next) >= maxScroll) {
        this.stopScroll()
        return
      }

      track.style.transform = `translate3d(${next}px, 0px, 0px)`
      this.scrollRaf = requestAnimationFrame(animate)
    }

    this.scrollRaf = requestAnimationFrame(animate)
  }

  stopScroll() {
    if (this.scrollRaf) {
      cancelAnimationFrame(this.scrollRaf)
      this.scrollRaf = null
    }

    this.#snapToNearestSlide()
  }

  // Private

  get #slider() { return $(this.sliderTarget) }
  get #track() { return this.sliderTarget.querySelector('.slick-track') }
  get #list() { return this.sliderTarget.querySelector('.slick-list') }

  #getTranslateX(el) {
    const matrix = new DOMMatrixReadOnly(getComputedStyle(el).transform)
    return matrix.m41
  }

  #snapToNearestSlide() {
    const track = this.#track
    if (!track) return

    const slick = this.#slider.slick('getSlick')
    const slideWidth = track.scrollWidth / slick.slideCount
    const nearestSlide = Math.round(Math.abs(this.#getTranslateX(track)) / slideWidth)

    this.#slider.slick('slickGoTo', nearestSlide, false)
  }

  #updateArrows() {
    const slick = this.#slider.slick('getSlick')
    this.prevBtnTarget.disabled = slick.currentSlide === 0
    this.nextBtnTarget.disabled = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow
  }
}
